define('GameDayCore/GDModel/ValueObjects/Plays/PlaysFileOffense',['require','exports','module','../ValueObjectFactory','ensureArray/ensureArray'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		ensureArray = require('ensureArray/ensureArray');

	VO.create(PlaysFileOffense);

	function PlaysFileOffense($data) {
		var vo = VO.ensureVO(this, PlaysFileOffense),
			data = $data,
			bases = { },
			baserunners = ensureArray(data.man);

		for (var i = 0, len = baserunners.length; i < len; i++) {
			if (baserunners[i].bnum == "4") {
				bases.b0 = baserunners[i];
			} else {
				bases["b" + baserunners[i].bnum] = baserunners[i];
			}
		}

		vo.id = data.id || "";
		vo.type = data.type || "";
		vo.home = bases.b0 || null;
		vo.first = bases.b1 || null;
		vo.second = bases.b2 || null;
		vo.third = bases.b3 || null;
	}

	return PlaysFileOffense;
});
